export function classNames(...args) {
  return [...args]
    .filter(className => {
      if (typeof className !== 'string') {
        return false;
      }

      return className.trim();
    })
    .join(' ')
    .trim();
}
